"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.QuoteSectionWidget = void 0;
var react_1 = __importDefault(require("react"));
var QuoteSectionContext_1 = require("./QuoteSectionContext");
var styles = __importStar(require("./QuoteSectionWidget.css"));
var classnames_1 = __importDefault(require("classnames"));
var kaleidoscope_1 = require("@qwilr/kaleidoscope");
var useQuoteLabel_1 = require("@CommonFrontend/Quote/useQuoteLabel");
var Types_1 = require("@CommonFrontendBackend/QuoteV2/Types");
var QuoteSectionWidget = function (_a) {
    var _b;
    var attributes = _a.attributes, heading = _a.heading, body = _a.body;
    var _c = (0, QuoteSectionContext_1.useQuoteSectionContext)(), components = _c.components, price = _c.price, section = _c.section, toggleSectionSelected = _c.actions.toggleSectionSelected;
    var getLabel = (0, useQuoteLabel_1.useQuoteLabel)();
    return (react_1.default.createElement("div", __assign({}, attributes, { className: (0, classnames_1.default)(attributes.className, styles.wrapper) }),
        react_1.default.createElement("div", { contentEditable: false }, components.OptionsMenu && (react_1.default.createElement("div", { "data-interactive-zone": true, className: styles.options },
            react_1.default.createElement(components.OptionsMenu, null)))),
        react_1.default.createElement("div", { className: styles.heading },
            react_1.default.createElement(kaleidoscope_1.Stack, { direction: "horizontal", align: "center" },
                react_1.default.createElement("div", { className: styles.headingContent }, heading),
                react_1.default.createElement("div", null,
                    react_1.default.createElement("div", null,
                        getLabel(Types_1.QuoteLabel.Section),
                        " ",
                        getLabel(Types_1.QuoteLabel.Price),
                        ": ", (_b = price["one-off"]) === null || _b === void 0 ? void 0 :
                        _b.quoted),
                    section.selection.mode === "optional" && (react_1.default.createElement("div", { "data-interactive-zone": true },
                        react_1.default.createElement(kaleidoscope_1.Button, { isRound: true, onClick: toggleSectionSelected, "aria-pressed": section.selection.selected }, section.selection.selected ? "Selected" : "Select")))))),
        react_1.default.createElement("div", { className: styles.body }, body)));
};
exports.QuoteSectionWidget = QuoteSectionWidget;
